import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import {
    appPayMethod,
    i18n,
    outputDiv,
    reCAPTCHAv3
} from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { DigitalDisbursements, dstPaymentIframeTitle, dstMember } from "commonAssets/components/FormBase/DigitalDisbursements";
import {
    FormFields,
    FormFieldsLabel,
} from "commonAssets/components/FormBase/FormFields";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { validateField } from "commonAssets/lib/validateField";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { modal } from "commonAssets/lib/modal";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { loadMember } from "commonAssets/lib/loadMember";
import formDefault from "../../docs/formDefault.json";
import claimDeadlineAlertBody from "../../docs/html/claim_deadline_alert_body.html?raw";
import claimDeadlineAlertForm from "../../docs/html/claim_deadline_alert_form.html?raw";
import generalInstructionsBody from "../../docs/html/general_instructions_body.html?raw";
import contactInformationBody from "../../docs/html/contact_information_body.html?raw";

const htmlAssets = {
    "./html/claim_deadline_alert_body.html": claimDeadlineAlertBody,
    "./html/claim_deadline_alert_form.html": claimDeadlineAlertForm,
    "./html/general_instructions_body.html": generalInstructionsBody,
    "./html/contact_information_body.html": contactInformationBody,
};

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const baseUrl = new URL(
            "../../docs/formDefault.json",
            window.location.href
        ).href;
        const config = await SubmitClaim.resolveHtmlFields(formDefault, {
            baseUrl,
            assets: htmlAssets,
        });
        const form = config.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    claim_form(params, additionalParams) {
        console.log("[claim_form]");
        // update the claim form deadline
        const deadline_heading =
            params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(
            deadline_heading,
            "text/html"
        );
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            [
                createElement(
                    "h3",
                    {
                        class: "text-center mb-3",
                        id: "claimFormDeadline",
                    },
                    [],
                    deadline_string.body.innerHTML
                ),
                createElement(
                    "div",
                    {
                        class: "alert alert-info text-center fw-bold text-dark",
                        id: "confirmation-email-alert",
                        role: "alert",
                    },
                    [],
                    params.form_options.claim_form.confirmation_email_notice
                ),
                this.claim_instructions(params),
                this.claim_contact_information(params),
                this.claim_fieldset(params),
                // params.claim_transactions
                //     ? this.claim_transactions(params)
                //     : ``,
                params.claim_upload.documentation.required
                    ? this.claim_documentation(params)
                    : ``,
                appPayMethod ? DigitalDisbursements(params) : ``,
                this.claim_certification(params),
            ]
        );
        return form;
    }

    claim_fieldset(params) {
        if (params.claim_fields === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const title = params.form_options.claim_form.claim_fields.title;
        const body = params.form_options.claim_form.claim_fields.body;
        const claimFields = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "claim-fields",
            },
            [
                createElement(
                    "div",
                    { class: "h3 mb-3 formTitle", id: "claimFieldsTitle" },
                    [],
                    title
                ),
                createElement(
                    "div",
                    { class: "mb-3 formBody", id: "claimFieldsBody" },
                    [],
                    body
                ),
                this.claim_fields(params),
                this.claim_transactions(params)
            ]
        );
        return claimFields;
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "transactions",
            },
            [
                createElement(
                    "div",
                    {
                        class: "h3 mb-3 formTitle",
                    },
                    [],
                    params.form_options.transactions.title
                ),
                createElement(
                    "div",
                    {
                        class: "mb-3 formBody",
                    },
                    [],
                    params.form_options.transactions.body
                ),
            ]
        );

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach((table) => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", {
                class: "table-responsive mb-3",
                id: "table_responsive_" + tableID,
            });

            // <table class="table transactions"></table>
            const tableTransaction = createElement(
                "table",
                {
                    class: "table table-hover transactions caption-top",
                    id: "transactions_" + tableID,
                    "data-table-name": table.name,
                    "data-table-id": tableID,
                },
                [
                    // createElement(
                    //     "caption",
                    //     { class: "text-dark bg-transparent" },
                    //     [],
                    //     "<strong>" +
                    //         table.name +
                    //         "</strong> &mdash; " +
                    //         table.description
                    // ),
                ]
            );
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", {
                class: "table-dark text-light",
            });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach((col) => {
                const column = createElement(
                    "th",
                    { scope: "col" },
                    [],
                    col.title
                );
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement(
                        "span",
                        {
                            class: "d-block fw-normal",
                            style: "font-size:16px;",
                        },
                        [],
                        col.body
                    );
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            const countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement(
                "div",
                {
                    class: "text-center",
                },
                [
                    createElement(
                        "a",
                        {
                            class: "btn btn-primary m-1",
                            id: "add_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label":
                                i18n.getTranslation("transaction_add_row") +
                                table.name,
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${table.name}`
                    ),
                    createElement(
                        "a",
                        {
                            // ada compliance updates - added
                            class: "btn btn-danger m-1 disabled", // default to disabled
                            id: "remove_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label": i18n.getTranslation(
                                "transaction_delete_row"
                            ),
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation("transaction_delete_row")}`
                    ),
                ]
            );

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(
                add_row,
                table,
                tableTBODY,
                tableID,
                countRow
            );

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);

        let fieldID = 0;
        table.fields.forEach((field) => {
            fieldID++;
            const td = createElement("td", {
                class: "transaction " + field.name,
            });
            const element = createElement("div");
            const validation = field.validation;

            const formInput = FormFields(
                field,
                "",
                fieldID,
                element,
                validation,
                fieldsRow
            );

            formInput.addEventListener('change', validateField);

            if (formInput.type == 'number') {
                formInput.addEventListener('change', (event) => {
                    const table = event.target.closest('table');
                    const inputs = table.querySelectorAll('input[type="number"]');
                    let rowTotal = 0;
                    inputs.forEach(input => {
                        const value = parseFloat(input.value);
                        if (!isNaN(value)) {
                            rowTotal += value;
                            input.value = value.toFixed(2);
                        }
                    });
                    const totalField = document.getElementById('oop_total');
                    if (totalField) {
                        totalField.value = rowTotal.toFixed(2);
                    }
                });
            }

            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);

            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);

            element.appendChild(formInput);
            
            td.appendChild(element);
            fieldsRow.appendChild(td);
            if (formInput.type == 'text' || formInput.type == 'textarea') {
                this.apply_letter_requirement([formInput.id]);
            }
        });
        return { tableTBODY, fieldsRow };
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({
            id: class_member.zero_zero_id,
            email: class_member.email_address,
        });
        // remove guard
        document.getElementById("guard").remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M.
        const deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Load member data into form
        loadMember(class_member);
        document.getElementById('first_name').disabled = document.getElementById('first_name').value;
        document.getElementById('last_name').disabled = document.getElementById('last_name').value;
        if (class_member.claim_id) {
            if (class_member.claim_files && class_member.claim_files.length > 0) {
                this.prev_uploads = true;
            }

            document.getElementById('signature').value = '';
        }
        // Payment widget
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_fields(claim, form, claim_deadline) {
        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        this.apply_letter_requirement(["street_address_1", "city", "expense-type__1", "description__1"]);

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("init");
        }

        // Check for file documentation section
        if (document.getElementById("documentation")) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {
            document.getElementById("form").setAttribute("novalidate", "true");

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            document
                .getElementById("submit-claim")
                .addEventListener("click", () => {
                    document
                        .getElementById("form")
                        .classList.add("was-validated");
                });

            document
                .getElementById("form")
                .addEventListener("submit", (process) => {
                    this.process_claim(process, this.claim, claim_deadline);
                });
        }

        if (this.customInitClaim != null) {
            this.claim = this.customInitClaim(this.claim) || this.claim;
        }

        document.getElementById('oop_total').disabled = true;

        if (!document.getElementById('out-of-pocket-expenses_0').checked) {
            document.getElementById('oop_total').parentElement.classList.add('d-none');
            document.getElementById('oop_total').value = '';
            document.getElementById('transactions').classList.add('d-none');
            document.querySelectorAll('input[item-id], textarea[item-id]').forEach((element) => {
                toggleFieldAttributeV2(element, "required", false);
            });
        }

        document.getElementById('out-of-pocket-expenses_0').addEventListener('change', (event) => {
            if (event.target.checked) {
                document.getElementById('oop_total').parentElement.classList.remove('d-none');
                document.getElementById('transactions').classList.remove('d-none');
                document.querySelectorAll('input[item-id], textarea[item-id]').forEach((element) => {
                    toggleFieldAttributeV2(element, "required", true);
                });
            } else {
                document.getElementById('oop_total').parentElement.classList.add('d-none');
                document.getElementById('transactions').classList.add('d-none');
                document.querySelectorAll('input[item-id], textarea[item-id]').forEach((element) => {
                    element.value = '';
                    toggleFieldAttributeV2(element, "required", false);
                    validateField(element);
                });
            }
        });

        loadingGif(loading, "hide", 1000);
    }

    apply_letter_requirement(fieldIds) {
        const letterRegex = "[A-Za-z]";

        fieldIds.forEach((id) => {
            const field = document.getElementById(id);
            if (!field) return;

            const validations = (field.getAttribute("data-validate") || "")
                .split(" ")
                .filter(Boolean);

            if (!validations.includes("required") && field.required) {
                validations.push("required");
            }

            if (!validations.includes("regex")) {
                validations.push("regex");
            }

            field.setAttribute("data-validate", validations.join(" "));
            field.setAttribute("data-regex", letterRegex);

            field.addEventListener("change", validateField);
        });
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input:not([item-id]), #claim-fields textarea:not([item-id]), #claim-fields select:not([item-id])";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions input, #transactions textarea, #transactions select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]");

        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        // Custom process claim
        if (this.customProcessClaim != null) {
            claim = this.customProcessClaim(this.claim);
        }

        let custom_errors = '';

        if (!document.getElementById('cash-fund-payment_0').checked && !document.getElementById('out-of-pocket-expenses_0').checked) {
            custom_errors += '<br>Please select at least one benefit type.';
            claim.flags.valid = false;
        }

        if (document.getElementById('out-of-pocket-expenses_0').checked && claim.uploads.length == 0 && !this.prev_uploads) {
            custom_errors += '<br>Please upload supporting documentation.';
            claim.flags.valid = false;
        }

        if (!$('#payment_method').val() || !$('#payment_token').val()) {
            custom_errors += '<br>Please select a method of payment.';
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('input.is-invalid, #file-notice.error, #no-files.error, #documentation.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            fbq('track', 'Lead');
            gtag_report_conversion();

            setTimeout(() => {
                modal(
                    i18n.getTranslation("confirmation_screen_additional")[
                        "title"
                    ],
                    i18n.getTranslation("confirmation_screen_additional")[
                        "body"
                    ]
                );
            }, 250);
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }
}
